import { api } from '../http';

const reprocessPncpIntegration = payload => {
  return api.post('/admin/pncp/reprocessar', payload);
};

export default reprocessPncpIntegration;
